import { H3 } from "../Headers/Headings";
import { useTranslations } from "../../contexts/Translation";
import { useSurvey } from "../../contexts/Survey";
import { useApiData } from "../../contexts/ApiData";
import Input from "../Forms/Input";
import { useState } from "react";
import Button, { IconButton } from "../Button/Button";
import { ValidationError } from "../../types";
import ErrorText from "../Forms/ErrorText";
import { CheckMark, Edit } from "../Icons";
import Comment from "../Comments/Comment";
import { MAX_NOTES } from "../../lib/textLimits";

type ComponentProps = {
  notes: string;
  responder: string;
};

export const ResponderNotes = ({ notes, responder }: ComponentProps) => {
  const t = useTranslations("surveys");
  const { post } = useApiData();
  const { survey, canEdit } = useSurvey();
  const [updatedNotes, setNotes] = useState(notes || "");
  const [isSaved, setIsSaved] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [errors, setErrors] = useState<ValidationError[]>([]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>) => {
    setIsSaved(false);
    setNotes(e.target.value);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const result = await post(`/response/${survey?.id}/responder/notes`, { responder, notes: updatedNotes });
    if (!result) {
      setErrors([{ name: "form", message: t("serverError") }]);
    } else {
      setIsSaved(true);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <ErrorText variant='form' error={errors.find((e) => e.name === "form")} />
      <H3 variant='noTop'>
        {t("responderNotesHeading")}
        {canEdit && (
          <IconButton active={isEdit} onClick={() => setIsEdit(!isEdit)}>
            <Edit />
          </IconButton>
        )}
      </H3>
      {canEdit && isEdit ? (
        <>
          <Input type='textarea' name='responderNotes' maxLength={MAX_NOTES} value={updatedNotes} handleChange={handleChange} />
          <Button>{t("submitResponderNotes")}</Button> {isSaved && <CheckMark />}
        </>
      ) : (
        <Comment preserveWhitespace>{updatedNotes || t("noResponderNotesText")}</Comment>
      )}
    </form>
  );
};
